<template>
  <div class="isis-pie-chart w-full" :class="getPieChartClasses()">
    <div
      class="legends"
      v-html="legendsHtml"
      :class="getLegendsClasses()"
      ref="legendsRef"
    ></div>
    <div class="chart flex-1">
      <core-component
        :chart-data="chartData"
        :tooltips-callback-cfg="tooltipsCallbackCfg"
        :legend-position="legendPosition"
        :legend-class-names="LegendClassNames"
        :width="width"
        :height="height"
        @generated-legends-html="setLegendsHtml"
        ref="chart"
        class="max-h-full"
      ></core-component>
    </div>
  </div>
</template>

<script>
import CoreComponent from "./CoreComponent.vue";

const LegendShapes = {
  circle: "circle",
  square: "square"
};

const LegendPositions = {
  top: "top",
  right: "right",
  bottom: "bottom",
  left: "left"
};

const LegendClassNames = {
  itemContainer: "isis-legend-item",
  label: "label"
};

export default {
  name: "pie-chart",
  props: [...CoreComponent.props, "chartData", "legendCfg", "width", "height"],
  components: { CoreComponent },
  data() {
    return {
      legendsHtml: "",
      LegendClassNames: LegendClassNames
    };
  },
  computed: {
    legendShape() {
      return LegendShapes[this.legendCfg?.shape] || LegendShapes["circle"];
    },
    legendPosition() {
      return (
        LegendPositions[this.legendCfg?.position] || LegendPositions["bottom"]
      );
    }
  },
  methods: {
    setLegendsHtml(legendsHtml) {
      this.legendsHtml = legendsHtml;
    },
    getLegendsClasses() {
      const shapeClass = this.legendShape;
      const positionClass = this.legendPosition;

      return [shapeClass, positionClass];
    },
    getPieChartClasses() {
      const layoutClass = `legend-${this.legendPosition}`;
      return [layoutClass];
    },
    setUpLegendClickEvent() {
      const container = this.$refs.legendsRef;
      const legendItemSelector = `.${LegendClassNames.itemContainer}`;

      const legendItems = [...container.querySelectorAll(legendItemSelector)];

      legendItems.forEach((item, i) => {
        item.addEventListener("click", e =>
          this.updateDataset(e.target.parentNode, i)
        );
      });
    },

    updateDataset(currentEl, index) {
      const chart = this.$refs.chart.$data._chart;
      const meta = chart.getDatasetMeta(0);
      const labelSeletor = `.${LegendClassNames.label}`;
      const labelEl = currentEl.querySelector(labelSeletor);
      const nextHidden = !meta.data[index].hidden;
      const shouldBeHidden = !!nextHidden;

      meta.data[index].hidden = nextHidden;
      labelEl.style.textDecoration = shouldBeHidden ? "line-through" : "none";

      chart.update();
    }
  },
  watch: {
    legendsHtml() {
      this.$nextTick(() => {
        this.setUpLegendClickEvent();
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.isis-pie-chart::v-deep .legends {
  ul {
    gap: 10px 20px;

    li.isis-legend-item {
      display: flex;
      align-items: center;

      span.icon {
        width: 20px;
        height: 20px;
        margin-right: 10px;
      }
    }
  }

  &.circle {
    span.icon {
      border-radius: 50%;
    }
  }

  &.left,
  &.right {
    ul {
      flex-direction: column;
    }
  }

  // Can using js to custom spacing
  &.top {
    margin-bottom: 6%;
  }

  &.bottom {
    margin-top: 6%;
  }

  &.left {
    margin-right: 10%;
  }

  &.right {
    margin-left: 10%;
  }
}

.isis-pie-chart {
  display: flex;

  &.legend-top {
    flex-direction: column;
  }

  &.legend-bottom {
    flex-direction: column-reverse;
  }

  &.legend-left {
    flex-direction: row;
  }

  &.legend-right {
    flex-direction: row-reverse;
    justify-content: flex-end;
  }
}
</style>
